import errorLogger from './errorLogger';

type DataLayerEventType = {
  event: string;
  [key: string]: unknown;
};

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

const pushInDataLayer = (event: DataLayerEventType): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  } else {
    errorLogger(new Error('pushInDataLayer: function was invoked while window was undefined.'));
  }
};

export default pushInDataLayer;
